import * as React from 'react';
import * as styles from './RootLayout.css';

export const RootLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['layout']}>{children}</div>;
};
